import React from 'react';
import ReactSVG from 'react-svg';
import { TimeToRespondIcon } from '~/assets/svgIcons';
import { Chip } from './styles';

const SLABreachedBadge = () => {
  return (
    <Chip
      data-test-id="sla-breached-badge"
      title="SLA Breached"
      label="SLA Breached"
      avatar={<ReactSVG src={TimeToRespondIcon} />}
    />
  );
};

export default SLABreachedBadge;
